var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.51 16.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "three"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79.28A3.29,3.29,0,0,0,4.5,2L.18,11.05a1.82,1.82,0,0,0-.11,1.3l1,3.43a.38.38,0,0,0,.51.24l3.3-1.37a1.93,1.93,0,0,0,1-.9l4.32-9A3.3,3.3,0,0,0,8.79.28ZM8.1,1.73A1.68,1.68,0,0,1,8.71,4l-.09.19L5.8,3l.14-.3A1.68,1.68,0,0,1,8.1,1.73ZM4.36,13.14h0a2.07,2.07,0,0,1-2.78-1.33h0L5.34,4,8.16,5.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.01b38c741be2420272209bd6860ca6d4.svg";
export { ForwardRef as ReactComponent };